/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import {
  Controller,
  FieldPath,
  FieldValues,
  ControllerProps,
} from "react-hook-form";
import { Input } from "@nordcloud/gnui";

type Props<
  TInput extends string,
  TOutput extends FieldValues[string],
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
> = Omit<ControllerProps<TFieldValues, TName>, "render"> &
  React.ComponentProps<typeof Input> & {
    transform: {
      input?: (value: TOutput) => TInput;
      output?: (value: React.ChangeEvent<HTMLInputElement>) => TOutput;
    };
  };
export function TransformableInput<
  TInput extends string,
  TOutput extends FieldValues[string],
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>
>({
  transform: {
    input = (val) => val as unknown as TInput,
    output = (val) => val as unknown as TOutput,
  },
  rules,
  name,
  shouldUnregister,
  defaultValue,
  control,
  ...props
}: Props<TInput, TOutput, TFieldValues, TName>) {
  return (
    <Controller
      rules={rules}
      name={name}
      shouldUnregister={shouldUnregister}
      defaultValue={defaultValue}
      control={control}
      render={({ field }) => (
        <Input
          onChange={(e) => field.onChange(output(e))}
          value={input(field.value)}
          {...props}
        />
      )}
    />
  );
}
